import { render, staticRenderFns } from "./add.vue?vue&type=template&id=1ee22dd3&scoped=true"
import script from "./add.js?vue&type=script&lang=js&external"
export * from "./add.js?vue&type=script&lang=js&external"
import style0 from "./add.vue?vue&type=style&index=0&id=1ee22dd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee22dd3",
  null
  
)

export default component.exports